export function SkeletonCard({ heightClass }: { heightClass: string }) {
  return (
    <div className={`card flex animate-pulse flex-col gap-3 ${heightClass}`} aria-hidden>
      <div className="h-5 w-1/3 rounded bg-grey-100" />
      <div className="h-3 w-2/3 rounded bg-grey-100" />
      <div className="flex-1" />
    </div>
  );
}
